import React from 'react';

import { SkeletonBlock, SkeletonOverlay, SkeletonTable, SKELETON_TOKENS } from 'components/shared';

const PANEL_FIELD_COUNT = 5;

export default function ReservationsSkeleton({ isLoading }: { isLoading: boolean }) {
    return (
        <SkeletonOverlay isLoading={isLoading}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                    height: 74,
                    padding: '0 24px',
                }}
            >
                <SkeletonBlock height={24} width={24} />
                <SkeletonBlock height={32} width={110} />
                <SkeletonBlock height={32} width={110} />
                <SkeletonBlock height={32} width={110} />
            </div>
            <div style={{ display: 'flex', flexGrow: 1 }}>
                <div style={{ flexGrow: 1 }}>
                    <SkeletonTable
                        columnWidths={[undefined, undefined, 80, 120, undefined]}
                        rowCount={10}
                    />
                </div>
                <div
                    style={{
                        width: 360,
                        padding: 24,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 12,
                        backgroundColor: SKELETON_TOKENS.sidePanel,
                        borderLeft: `1px solid ${SKELETON_TOKENS.divider}`,
                    }}
                >
                    <SkeletonBlock height={24} width="60%" />
                    {Array.from({ length: PANEL_FIELD_COUNT }, (_, i) => (
                        <SkeletonBlock key={i} height={40} />
                    ))}
                    <SkeletonBlock height={36} width={140} style={{ marginTop: 'auto' }} />
                </div>
            </div>
        </SkeletonOverlay>
    );
}
